import React from 'react'
import { NavLink, useLocation } from 'react-router-dom'
import { useLastMechanicalProjectId } from '../../mechanical-tests/useLastMechanicalProjectId'

const MECH_PROJECT_FROM_PATH = /^\/projects\/([^/]+)\/mechanical-tests(?:\/.*)?$/
const MECH_REPORTS_EXACT = /^\/projects\/[^/]+\/mechanical-tests\/reports$/

const items = [
  { to: '/wizard', label: 'Wizard' },
  { to: '/library', label: 'Library' },
  { to: '/resources', label: 'Projects' },
  { to: '/settings', label: 'Settings' }
]

function chipClass(isActive: boolean) {
  return `px-3 py-1.5 rounded-full text-[11px] font-medium whitespace-nowrap transition-colors ${
    isActive
      ? 'bg-hero-red/10 text-hero-red border border-hero-red/20'
      : 'bg-page-bg text-heritage-grey border border-transparent'
  }`
}

export default function MobileNav() {
  const { pathname } = useLocation()
  const lastMechanicalProjectId = useLastMechanicalProjectId()
  const mechProjectId = pathname.match(MECH_PROJECT_FROM_PATH)?.[1] ?? lastMechanicalProjectId
  const isMechanicalReports = MECH_REPORTS_EXACT.test(pathname)

  return (
    <div className="lg:hidden border-b border-[#E2E5EA] bg-white/90 backdrop-blur px-4 py-3">
      <div className="flex items-center gap-3 overflow-x-auto">
        {items.map((item) => (
          <NavLink
            key={item.to}
            to={item.to}
            className={({ isActive }) => chipClass(isActive)}
          >
            {item.label}
          </NavLink>
        ))}
        {isMechanicalReports && mechProjectId ? (
          <>
            <NavLink
              to={`/projects/${mechProjectId}/mechanical-tests`}
              end
              className={({ isActive }) => chipClass(isActive)}
            >
              Mech. overview
            </NavLink>
            <NavLink
              to={`/projects/${mechProjectId}/mechanical-tests/upload`}
              className={({ isActive }) => chipClass(isActive)}
            >
              Mech. upload
            </NavLink>
            <NavLink
              to={`/projects/${mechProjectId}/mechanical-tests/analytics`}
              className={({ isActive }) => chipClass(isActive)}
            >
              Mech. analytics
            </NavLink>
          </>
        ) : null}
      </div>
    </div>
  )
}
